import { params, const_var } from "../../redux/reducers/reducer.js";
import axios from "axios";
import { callTaxApiAndCalculatePrice } from "../index";
import { prepareTwoDMapData } from "../2d_mapping/twoDMap.action.js";
import { customerListService, leadListService, leadSourceService } from "../../services/quote-order.service.js";
import { getDealerStateList } from "../manufacturers_auth/manufacture.action.js";
import { submitBuildingData } from "../../helpers/quote_order/leadCustomerHelper.js";
import { taxFromZip } from "../../services/manufacture.services.js";
export function SendBuildingDatatoServer() {
	return (dispatch, getState) => {
		dispatch(submitBuildingData());
	};
}

export function GenrateBuildingDatatoServer(e, key) {
	return (dispatch) => {
		dispatch({ type: "GenrateBuildingDatatoServer", event: e, key: key });
	};
}
export function handleProductModal(e) {
	return {
		type: "handleProductModal",
		value: e
	};
}

export function showMoreErr(val) {
	return {
		type: "showMoreWithErr",
		value: val
	};
}

export function getDefaultLeadCustomerData() {
	return (dispatch) => {
		let searchParam = {
			user_id: const_var.crmSetting.login_user_id,
			api_token: const_var.crmSetting.api_token,
			search_text: "",
			limit: 100,
			offset: 0,
			module: const_var.crmSetting.sub_module,
			module_id: const_var.crmSetting.sub_module_id,
			company_id: params.company_id
		};
		if (const_var.crmSetting.is_CRM == true) {
			searchParam = {
				user_id: const_var.crmSetting.login_user_id,
				api_token: const_var.crmSetting.api_token,
				search_text: "",
				limit: 100,
				offset: 0,
				module: const_var.crmSetting.sub_module,
				module_id: const_var.crmSetting.sub_module_id
			};
		}
	};
}
export function onSearchRecords(e, key, value) {
	e.preventDefault();
	value = e.target[0].value;
	return (dispatch) => {
		const apiCall = const_var.crmSetting.sub_module === "lead" ? leadListService : customerListService;
		return apiCall(const_var.crmSetting.login_user_id, value, 100)
			.then((response) => {
				dispatch({
					type: "onSearchRecords",
					event: e,
					value: response,
					key: key,
					search_text: value
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};
}
export function handleCommonModal(e, chksave, flag) {
	let error = false;
	let checkError = Object.entries(const_var.displayerrorMessage);
	checkError?.length > 0 &&
		checkError.map(([key, value]) => {
			if (value != "") {
				error = true;
			}
		});
	if (
		chksave != undefined &&
		error == false &&
		Object.keys(const_var.LeadCustomerData).length > 0 &&
		const_var.LeadCustomerData.first_name != undefined &&
		const_var.LeadCustomerData.first_name != "" &&
		const_var.LeadCustomerData.last_name != undefined &&
		const_var.LeadCustomerData.last_name != ""
	) {
		if (const_var.crmSetting.is_klink_generated == true && flag == undefined) {
			return {
				type: "ManageKlinkExpire",
				value: false
			};
		} else {
			return {
				type: "GenrateBuildingDatatoServer",
				event: "",
				key: "genrate"
			};
		}
	} else {
		if (e == "lead_customer") {
			const removea = document.querySelector("body");
			removea.classList.remove("active-total-price");
			return (dispatch) => {
				dispatch({
					type: "handleCommonModal",
					value: "",
					event: e
				});
				dispatch(prepareTwoDMapData());
				if (const_var.leadSourceData == "") {
					return leadSourceService()
						.then((response) => {
							dispatch({
								type: "handleCommonModal",
								value: response.data,
								event: e
							});
						})
						.catch((error) => {
							console.log(error, "error");
						});
				}
			};
		} else if (e == "terms_conditions") {
			return {
				type: "handleCommonModal",
				value: "terms_conditions",
				event: e
			};
		} else {
			return {
				type: "handleCommonModal",
				value: "close",
				event: e
			};
		}
	}
}

export function handleCustomerData(e, row, isSelect, rowIndex, eventType) {
	Object.entries(row).map(([key, value]) => {
		if (value == null || value == "null") {
			row[key] = "";
		}
	});
	return (dispatch) => {
		dispatch({
			type: "handleCustomerData",
			event: e,
			row: row,
			isSelect: isSelect,
			rowIndex: rowIndex,
			eventType: eventType
		});
		if (const_var.crmSetting.is_Edit != true && eventType == undefined && row.address && row.address.length == 0) {
			dispatch(callTaxApiAndCalculatePrice(undefined)); // we did this to resolve SE3-I5323 issue
		}
		if (const_var.LeadCustomerData.showZip != undefined) {
			let zipData = { zip_code: const_var.LeadCustomerData.showZip };
			return taxFromZip(zipData).then(function (response1) {
				if (response1.data.status == false) {
					dispatch({
						type: "handleCustomerDataWithAPI",
						event: "",
						responseData: ""
					});
				} else {
					dispatch({
						type: "handleCustomerDataWithAPI",
						event: "",
						responseData: response1.data
					});
				}
			});
		} else {
			const_var.MoreTaxinputs = [];
		}
	};
}
export function commonsActionforLeadCustomer(e, key) {
	return {
		type: "commonsActionforLeadCustomer",
		value: e,
		key: key
	};
}

export function EditCustomerLeadRecord(e, key, data, index, from) {
	return (dispatch) => {
		if (key == "editAdd") {
			dispatch({
				type: "EditCustomerLeadRecord",
				key: key,
				event: e,
				data: data,
				index: index,
				from: from
			});
		}
	};
}
export function readyCaptured(e, key) {
	return (dispatch) => {
		if (key == "ready") {
			dispatch({
				type: "readyCaptured",
				event: e
			});
		}
	};
}
export function AddCustomerLeadRecord(e, key) {
	return (dispatch) => {
		if (key == "billing") {
			dispatch({ type: "AddCustomerLeadRecord", event: e, key: "billing_create" });
			if (const_var.checkValidate == false && key == "billing") {
				dispatch({ type: "AddCustomerLeadRecord", event: e, key: "save" });

				dispatch({ type: "AddCustomerLeadRecord", event: e, key: "billing" });
				dispatch(GenrateBuildingDatatoServer(e));
			}
		} else {
			dispatch({ type: "AddCustomerLeadRecord", event: e, key: key });
			if (const_var.checkValidate == false && key == "create") {
				dispatch({ type: "AddCustomerLeadRecord", event: e, key: "save" });
				dispatch(handleCommonModal("handleCommonModal", "lead_customer", "save"));
			}
		}
	};
}

export function AddEditAddressRecord(e) {
	return (dispatch) => {
		dispatch({
			type: "AddEditAddressRecord",
			event: e,
			key: "create"
		});
		if (const_var.checkValidate == false) {
			dispatch({ type: "AddEditAddressRecord", event: e, key: "save" });
		}
		if (const_var.isSetZip == true && const_var.crmSetting.is_Edit != true) {
			dispatch(callTaxApiAndCalculatePrice(const_var.LeadCustomerData.address[0].zipcode));
			const_var.isSetZip = false;
		}
		if (const_var.LeadCustomerData && const_var.LeadCustomerData.address && const_var.LeadCustomerData.address.length > 0 && const_var.crmSetting.is_Edit != true) {
			let defaultAdd = const_var.LeadCustomerData.address.filter((obj) => obj.is_billing == 1);
			defaultAdd = defaultAdd[0];
			if (defaultAdd.zipcode != undefined && defaultAdd.zipcode != params.tax_zipcode) {
				dispatch(callTaxApiAndCalculatePrice(defaultAdd.zipcode));
			}
		}
	};
}
export function AddEditAddressInfo(e, key, is_Checked, isRecChecked) {
	return (dispatch) => {
		dispatch({
			type: "AddEditAddressInfo",
			event: e,
			key: key,
			is_Checked: is_Checked
		});
		if (
			const_var.crmSetting.is_Edit != true &&
			key == "add" &&
			const_var.LeadCustomerData &&
			(const_var.LeadCustomerData.address == undefined || (const_var.LeadCustomerData.address && const_var.LeadCustomerData.address.length == 0))
		) {
			const_var.isSetZip = true;
		}
		if (const_var.crmSetting.is_Edit != true && key == "update" && is_Checked == "is_billing" && const_var.LeadCustomerData && const_var.LeadCustomerData.address && const_var.LeadCustomerData.address.length > 0) {
			dispatch(callTaxApiAndCalculatePrice(const_var.LeadCustomerData.address[e].zipcode));
		}
	};
}
export function onAddressFiledChangeValue(e, name, keyword, flag, ValidationCheck, editEmail, from) {
	return (dispatch) => {
		dispatch({
			type: "onAddressFiledChangeValue",
			event: e,
			value: name,
			keyword: keyword,
			flagg: flag,
			ValidationCheck: ValidationCheck,
			editEmail: editEmail,
			from: from
		});
	};
}
export function onTextFiledChangeValue(e, name, keyword, flag, ValidationCheck, editEmail) {
	return (dispatch) => {
		dispatch({
			type: "onTextFiledChangeValue",
			event: e,
			value: name,
			keyword: keyword,
			flagg: flag,
			ValidationCheck: ValidationCheck,
			editEmail: editEmail
		});
	};
}

export function editUserAddress(e, name, keyword, addressId, from) {
	return (dispatch) => {
		dispatch({
			type: "editUserAddress",
			event: e,
			value: name,
			keyword: keyword,
			addressId: addressId,
			from: from
		});
	};
}

export function CheckEditQuoteAlertBox(val, key) {
	return (dispatch) => {
		dispatch({
			type: "CheckEditQuoteAlertBox",
			value: val,
			key: key
		});
		if (key == "edithere") {
			const_var.crmSetting.is_Edit = true;
			dispatch(getDealerStateList());
		}
	};
}
